import { render, staticRenderFns } from "./EnvironmentIcon.vue?vue&type=template&id=3538c5b7&scoped=true&"
import script from "./EnvironmentIcon.vue?vue&type=script&lang=ts&"
export * from "./EnvironmentIcon.vue?vue&type=script&lang=ts&"
import style0 from "./EnvironmentIcon.vue?vue&type=style&index=0&id=3538c5b7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3538c5b7",
  null
  
)

export default component.exports